export class CustomError {

    private _name!: string;

    get message(): string | undefined {
        return this._message;
    }

    set message(v: string | undefined) {
        this._message = v;
    }

    get code(): number | undefined {
        return this._code;
    }

    set code(v: number | undefined) {
        this._code = v;
    }

    get name() {
        return this._name;
    }

    set name(v: string) {
        this._name = v;
    }


    constructor(
        private _message?: string,
        private _code?: number) {
    }
}
